import type { ToastDesignTokens } from '@primeuix/themes/types/toast';

/**
 * Toast component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/toast/index.ts
 *
 * Component documentation:
 * https://primeng.org/toast
 */
export const toastComponentTokens: Partial<ToastDesignTokens> = {
  colorScheme: {
    light: {
      warn: {
        color: '{yellow.900}',
      },
    },
  },
};
